import { createSlice } from '@reduxjs/toolkit';
import { TeamRole } from 'containers/app/app.model';
import { RootState } from 'store/reducers';
import { CommissionRule } from 'containers/settings/commission-settings/commissionSettings.model';
import { ServiceArea } from 'containers/settings/service-areas/serviceAreas.model';
import { MAP_COLOR_PRESETS } from './constants';

export interface CreateInviteState {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  role: TeamRole;
  selectedServiceAreas: ServiceArea[];
  selectedCommissionRules: CommissionRule[];
  mapColor: string;
}

const initialState: CreateInviteState = {
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  role: TeamRole.MEMBER,
  selectedServiceAreas: [],
  selectedCommissionRules: [],
  mapColor: MAP_COLOR_PRESETS[0]
};

export const createInviteSlice = createSlice({
  name: 'createInvite',
  initialState,
  reducers: {
    resetInviteDetails: () => initialState,
    updateBasicDetails: (state, { payload }) => {
      const { value, field } = payload;
      state[field] = value;
    },
    updateMemberRole: (state, { payload }) => {
      state.role = payload;
    },
    updateSelectedServiceAreas: (state, { payload }) => {
      state.selectedServiceAreas = payload;
    },
    updateSelectedCommissionRules: (state, { payload }) => {
      state.selectedCommissionRules = payload;
    },
    updateMapColor: (state, { payload }) => {
      state.mapColor = payload;
    }
  }
});

export const {
  updateBasicDetails,
  updateMemberRole,
  resetInviteDetails,
  updateSelectedServiceAreas,
  updateSelectedCommissionRules,
  updateMapColor
} = createInviteSlice.actions;

export const selectInviteMemberRole = (state: RootState) => state.rootReducer.createInvite.role;
export const selectInviteMemberFirstName = (state: RootState) => state.rootReducer.createInvite.firstName;
export const selectInviteMemberLastName = (state: RootState) => state.rootReducer.createInvite.lastName;
export const selectInviteMemberPhone = (state: RootState) => state.rootReducer.createInvite.phone;
export const selectInviteMemberEmail = (state: RootState) => state.rootReducer.createInvite.email;
export const selectSelectedServiceAreas = (state: RootState) => state.rootReducer.createInvite.selectedServiceAreas;
export const selectSelectedCommissionRules = (state: RootState) =>
  state.rootReducer.createInvite.selectedCommissionRules;
export const selectMapColor = (state: RootState) => state.rootReducer.createInvite.mapColor;

export default createInviteSlice.reducer;
